import { fetchLatestPaperFinderState } from '@/store/thunks/FetchPaperFinder';
import { getActiveWidgetDataForThread } from '@/store/reducers/PaperFinderWidgetStore';
import { MultiToolChat } from '@/components/chat/MultitoolChat';
import { openPaperFinderWidget } from '@/store/actionCreators/WidgetActions';
import { Thread } from '@/models/Thread';
import { useAppDispatch, useAppSelector } from '@/store/hooks';

import { useEffect } from 'react';

interface PaperFinderChatProps {
  thread: Thread;
  onSendMessage: (text: string) => Promise<void>;
  isMessageBarPending: boolean;
}

export const PaperFinderChat = ({
  thread,
  isMessageBarPending,
  onSendMessage,
}: PaperFinderChatProps) => {
  const dispatch = useAppDispatch();
  const paperFinderData = useAppSelector((state) =>
    getActiveWidgetDataForThread(state, thread.id),
  );

  useEffect(() => {
    if (thread) {
      dispatch(fetchLatestPaperFinderState(thread.id));
    }
  }, [thread.id]);

  // auto-open the paper finder widget on load when the data is available
  useEffect(() => {
    if (paperFinderData) {
      dispatch(
        openPaperFinderWidget({
          threadId: thread.id,
          widgetId: paperFinderData.id,
        }),
      );
    }
  }, [paperFinderData]);

  return (
    <MultiToolChat
      thread={thread}
      onSendMessage={onSendMessage}
      isMessageBarPending={isMessageBarPending}
    />
  );
};
